import type {ReactElement} from 'react';
import {useEffect, useRef} from 'react';
import {Text, TextSize} from '@Components/text';
import {getCreditUsageText} from '@Libraries/credit-usage.library';
import type {CreditUsageNoticeProps} from '@Components/ai-resdesign-prompt-box/components/credit-usage-notice/credit-usage-notice.types';
import styles from '@Components/ai-resdesign-prompt-box/components/credit-usage-notice/credit-usage-notice.module.scss';

export function CreditUsageNotice({creditUsage}: CreditUsageNoticeProps): ReactElement {
  const visible = creditUsage !== undefined;
  const lastVisibleValuesRef = useRef(creditUsage);
  const displayValues = creditUsage ?? lastVisibleValuesRef.current;

  useEffect(() => {
    if (creditUsage) {
      lastVisibleValuesRef.current = creditUsage;
    }
  }, [creditUsage]);

  const usageText = getCreditUsageText(displayValues?.creditsCharged ?? 0, displayValues?.remainingCredits ?? 0);

  return (
    <div className={`${styles.wrapper} ${visible ? styles.open : ''}`}>
      <div className={styles.panel}>
        <div className={styles.panelInner}>
          <Text dangerouslySetInnerHTML size={TextSize.SM} val={usageText} />
        </div>
      </div>
    </div>
  );
}
